import { useTranslate } from '@tolgee/react';
import { Space, Tabs } from 'antd';
import { QueryReturnListStateCountV2Resp, SecondaryProcessStatus } from 'services/api/refund';
import { getCount } from '../utils/count';
import { usePlatform } from '../hooks/usePlatformList';
import { SyncButton } from './SyncButton';
import { ExportButton } from './ExportButton';
import { StatusFilter } from '../hooks/useReturnList';
import { FilterState } from '../hooks/useFilter';

interface ReturnListTabsProps {
  query: FilterState;
  statusCount?: QueryReturnListStateCountV2Resp;
  statusFilter: StatusFilter;
  secondaryProcessStatus: SecondaryProcessStatus;
  onChange: (key: any) => void;
}

/**
 * Lazada 平台不在此处渲染, 在 LazadaReturnList.tsx
 */
export const ReturnListTabs = (props: ReturnListTabsProps) => {
  const { query, statusFilter, statusCount, secondaryProcessStatus, onChange } = props;
  const { t } = useTranslate();
  const platform = usePlatform()!;

  if (platform === 'SHOPEE') {
    return (
      <Tabs
        activeKey={statusFilter}
        onChange={onChange}
        tabBarExtraContent={
          <div className="flex px-4 gap-4">
            <ExportButton
              statusFilter={statusFilter}
              query={query}
              secondaryProcessStatus={secondaryProcessStatus}
              platform={platform}
            />
            <SyncButton />
          </div>
        }
      >
        <Tabs.TabPane tab={`${t(`orderStatus.ALL`)}(${getCount(statusCount?.total)})`} key="ALL" />
        <Tabs.TabPane
          tab={`${t(`orderStatusShopee.REQUEST`)}(${getCount(statusCount?.requestCount)})`}
          key="REQUEST"
        />
        <Tabs.TabPane
          tab={`${t(`orderStatusShopee.PENDING`)}(${getCount(statusCount?.pendingCount)})`}
          key="PENDING"
        />
        <Tabs.TabPane
          tab={
            <Space>
              {`${t(`orderStatusShopee.PROCESSED`)}(${getCount(statusCount?.processedCount)})`}
            </Space>
          }
          key="PROCESSED"
        />
        <Tabs.TabPane
          tab={`${t(`orderStatusShopee.COMPLETE`)}(${getCount(statusCount?.completeCount)})`}
          key="COMPLETE"
        />
      </Tabs>
    );
  }

  if (platform === 'MERCADO') {
    return (
      <Tabs activeKey={statusFilter} onChange={onChange}>
        <Tabs.TabPane tab={`${t('orderStatus.ALL')}(${getCount(statusCount?.total)})`} key="ALL" />
        <Tabs.TabPane
          tab={`${t('待卖家处理')}(${getCount(statusCount?.pendingCount)})`}
          key="PENDING"
        />
        <Tabs.TabPane
          tab={`${t('待买家处理')}(${getCount(statusCount?.buyerPendingCount)})`}
          key="BUYER_PENDING"
        />
        <Tabs.TabPane
          tab={`${t('调解中')}(${getCount(statusCount?.mediationCount)})`}
          key="MEDIATION"
        />
        <Tabs.TabPane
          tab={`${t('feedback.已关闭')}(${getCount(statusCount?.completeCount)})`}
          key="COMPLETE"
        />
      </Tabs>
    );
  }

  if (platform === 'KWAI') {
    return (
      <Tabs activeKey={statusFilter} onChange={onChange}>
        <Tabs.TabPane tab={`${t('orderStatus.ALL')}(${getCount(statusCount?.total)})`} key="ALL" />
        <Tabs.TabPane
          tab={`${t('待处理')}(${getCount(statusCount?.pendingCount)})`}
          key="PENDING"
        />
        <Tabs.TabPane
          tab={`${t('售后完成')}(${getCount(statusCount?.completeCount)})`}
          key="COMPLETE"
        />
        <Tabs.TabPane tab={`${t('售后关闭')}(${getCount(statusCount?.closedCount)})`} key="CLOSE" />
      </Tabs>
    );
  }

  return (
    <Tabs
      activeKey={statusFilter}
      onChange={onChange}
      tabBarExtraContent={
        <div className="flex px-4 gap-4">
          <ExportButton
            statusFilter={statusFilter}
            query={query}
            secondaryProcessStatus={secondaryProcessStatus}
            platform={platform}
          />
        </div>
      }
    >
      <Tabs.TabPane tab={`${t('orderStatus.ALL')}(${getCount(statusCount?.total)})`} key="ALL" />
      <Tabs.TabPane
        tab={`${t('orderStatus.PENDING')}(${getCount(statusCount?.pendingCount)})`}
        key="PENDING"
      />
      <Tabs.TabPane
        tab={`${t('orderStatus.PROCESS')}(${getCount(statusCount?.processCount)})`}
        key="PROCESS"
      />
      <Tabs.TabPane
        tab={`${t(`orderStatus.COMPLETE`)}(${getCount(statusCount?.completeCount)})`}
        key="COMPLETE"
      />
    </Tabs>
  );
};
